/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import UserAPI from '@/api/UserAPI.js';
import {
	ResetModules,
	ModuleLicenseInfo,
	ModuleTaxPayerInfo,
	ModuleCompany,
	ModuleOptions,
	ModuleServiceTVAN,
	ModuleUser
} from '../module-const';
import store from '../store';

export default {
	changeTaxCode: async function(context, item) {
		let res = await httpClient.postAsync(
			{
				url: UserAPI.getAPIUrl() + '/updateworking',
				data: { TaxCodeWorking: item.TaxCode }
			},
			true
		);

		//Đổi mã số thuế làm việc thành công
		if (res.Success) {
			//Reset state
			ResetModules.forEach(m => store.commit(`${m}/resetState`));

			// Cập nhật thông tin công ty
			store.commit(
				`${ModuleCompany}/updateCompanyInfo`,
				res.Data.RoleUser
			);

			// Cập nhật lại license
			store.commit(
				`${ModuleLicenseInfo}/updateLicenseInfo`,
				res.Data.LicenseInfo
			);

			//Cập nhật thông tin người nộp thuế
			store.commit(
				`${ModuleTaxPayerInfo}/setTaxPayerInfo`,
				res.Data.TaxPayerInfo
			);

			// Cập nhật UserTax hiện tại (theo MisaId + TaxCode làm việc) — dùng cho getter AmisConvertStatus của user đăng nhập
			store.commit(`${ModuleUser}/setCurrentUserTax`, res.Data.UserTax);

			//Cập nhật thông tin tùy chọn của hệ thống
			store.commit(
				`${ModuleOptions}/updateOptionsData`,
				res.Data.OptionsData
			);

			//Cập nhật thông tin khai thuế
			store.commit(
				`${ModuleServiceTVAN}/updateDecServiceRegisInfo`,
				res.Data.DecRegis
			);

			//Cập nhật thông tin nộp thuế
			store.commit(
				`${ModuleServiceTVAN}/updatePayServiceRegisInfo`,
				res.Data.PayRegis
			);
		}

		// Trả kết quả
		return res;
	}
};
